/**
 * Do not edit directly
 */
export const primitives = {
  "color": {
    "primitive": {
      "blue": {
        "50": "#eff6ff",
        "100": "#dbeafe",
        "150": "#c5e3ff",
        "200": "#bfdbfe",
        "250": "#bae7ff",
        "300": "#93c5fd",
        "400": "#60a5fa",
        "450": "#4abfe5",
        "500": "#3b82f6",
        "550": "#1890ff",
        "600": "#1659cb",
        "650": "#085492",
        "700": "#065492",
        "750": "#1d4ed8",
        "800": "#1e40af",
        "900": "#1e3a8a"
      },
      "cyan": {
        "50": "#f4f9fa",
        "100": "#cffafe",
        "200": "#a5f3fc",
        "300": "#67e8f9",
        "400": "#22d3ee",
        "500": "#06b6d4",
        "600": "#0891b2",
        "700": "#0e7490",
        "800": "#155e75",
        "900": "#164e63"
      },
      "green": {
        "50": "#f0fdf4",
        "75": "#f6ffed",
        "100": "#dcfce7",
        "200": "#bbf7d0",
        "300": "#86efac",
        "350": "#52c41a",
        "400": "#4ade80",
        "450": "#4cba38",
        "500": "#22c55e",
        "550": "#20b249",
        "600": "#16a34a",
        "650": "#028700",
        "700": "#15803d",
        "750": "#008000",
        "800": "#166534",
        "900": "#14532d"
      },
      "red": {
        "50": "#fef2f2",
        "100": "#fee2e2",
        "200": "#fecaca",
        "300": "#fca5a5",
        "350": "#ff7979",
        "400": "#f87171",
        "450": "#ff4d4f",
        "500": "#ef4444",
        "550": "#ec544a",
        "600": "#dc2626",
        "650": "#d40b00",
        "700": "#b91c1c",
        "750": "#e81a1a",
        "800": "#991b1b",
        "900": "#7f1d1d"
      },
      "orange": {
        "50": "#fff7ed",
        "100": "#ffedd5",
        "200": "#fed7aa",
        "300": "#fdba74",
        "400": "#fb923c",
        "500": "#f97316",
        "600": "#ea580c",
        "700": "#c2410c",
        "800": "#9a3412",
        "900": "#7c2d12"
      },
      "yellow": {
        "50": "#fefce8",
        "100": "#fef9c3",
        "200": "#fef08a",
        "300": "#fde047",
        "400": "#facc15",
        "500": "#eab308",
        "600": "#ca8a04",
        "700": "#a16207",
        "800": "#854d0e",
        "900": "#713f12"
      },
      "purple": {
        "50": "#faf5ff",
        "100": "#f3e8ff",
        "200": "#e9d5ff",
        "300": "#d8b4fe",
        "400": "#c084fc",
        "500": "#a855f7",
        "600": "#9333ea",
        "700": "#7c3aed",
        "800": "#6b21a8",
        "900": "#581c87"
      },
      "pink": {
        "50": "#fdf2f8",
        "100": "#fce7f3",
        "200": "#fbcfe8",
        "300": "#f9a8d4",
        "400": "#f472b6",
        "500": "#ec4899",
        "600": "#db2777",
        "700": "#be185d",
        "800": "#9d174d",
        "900": "#831843"
      },
      "gray": {
        "50": "#fafafa",
        "100": "#f5f5f5",
        "200": "#e5e5e5",
        "300": "#d4d4d4",
        "400": "#a3a3a3",
        "500": "#737373",
        "600": "#525252",
        "700": "#404040",
        "800": "#262626",
        "900": "#171717"
      },
      "neutral": {
        "25": "#fcfcff",
        "50": "#fafafa",
        "100": "#f5f5f5",
        "150": "#f5f4f2",
        "200": "#f0f2f6",
        "250": "#e5e5e5",
        "300": "#d9d9d9",
        "400": "#a3a3a3",
        "500": "#979797",
        "600": "#666666",
        "650": "#595959",
        "700": "#525252",
        "750": "#404040",
        "800": "#333333",
        "850": "#262626",
        "900": "#111111",
        "950": "#0f1e37"
      },
      "tan": {
        "100": "#f9f9f9",
        "200": "#f5f5f5",
        "300": "#eed3ab",
        "400": "#d4c5a9"
      },
      "sky": {
        "50": "#f5fcff",
        "100": "#eff8fe",
        "200": "#e6f7ff",
        "300": "#bae7ff",
        "400": "#91d5ff",
        "500": "#69c0ff",
        "600": "#40a9ff"
      },
      "white": {
        "0": "#ffffff"
      },
      "black": {
        "900": "#000000"
      }
    }
  },
  "spacing": {
    "0": "0px",
    "1": "4px",
    "2": "8px",
    "3": "12px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "7": "28px",
    "8": "32px"
  },
  "typography": {
    "fontFamily": {
      "primary": "'Open Sans', sans-serif"
    },
    "fontSize": {
      "xxs": "8px",
      "xs": "10px",
      "sm": "12px",
      "md": "14px",
      "lg": "16px",
      "xl": "20px",
      "xxl": "24px",
      "xxxl": "32px"
    },
    "fontWeight": {
      "regular": "400",
      "medium": "500",
      "semibold": "600",
      "bold": "700"
    },
    "lineHeight": {
      "none": "1",
      "tight": "1.2",
      "snug": "1.375",
      "normal": "1.5",
      "relaxed": "1.625",
      "loose": "1.75"
    }
  },
  "radius": {
    "none": "0px",
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "20px",
    "full": "50%"
  },
  "border": {
    "width": {
      "0": "0px",
      "sm": "1px",
      "md": "2px",
      "lg": "4px"
    }
  },
  "shadow": {
    "none": "none",
    "xs": "0 1px 2px rgba(0,0,0,0.05)",
    "sm": "0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06)",
    "md": "0 4px 6px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.06)",
    "lg": "0 10px 15px rgba(0,0,0,0.1), 0 4px 6px rgba(0,0,0,0.05)",
    "xl": "0 20px 25px rgba(0,0,0,0.1), 0 10px 10px rgba(0,0,0,0.04)",
    "2xl": "0 25px 50px rgba(0,0,0,0.25)",
    "dark": {
      "xs": "0 1px 2px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.05)",
      "sm": "0 1px 3px rgba(0,0,0,0.4), 0 1px 2px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.05)",
      "md": "0 4px 6px rgba(0,0,0,0.5), 0 2px 4px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.05)",
      "lg": "0 10px 15px rgba(0,0,0,0.5), 0 4px 6px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.05)",
      "xl": "0 20px 25px rgba(0,0,0,0.6), 0 10px 10px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.05)",
      "2xl": "0 25px 50px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.05)"
    }
  },
  "opacity": {
    "0": 0,
    "5": 0.05,
    "10": 0.1,
    "20": 0.2,
    "40": 0.4,
    "50": 0.5,
    "60": 0.6,
    "70": 0.7,
    "80": 0.8,
    "90": 0.9,
    "100": 1
  },
  "alpha": {
    "0": "00",
    "5": "0D",
    "10": "1A",
    "20": "33",
    "30": "4D",
    "40": "66",
    "50": "80",
    "60": "99",
    "70": "B3",
    "80": "CC",
    "90": "E6",
    "100": "FF"
  }
};
